import { Injectable } from '@angular/core';

import { CRUDGenericService } from 'attcei-bo-fw';
import { Observable, Subscriber } from 'rxjs';
import { PaginatedDTO } from '../../route/route-builder/dto/PaginatedDTO';
import { LocationDTO } from './LocationDTO';


class InternalState {
    constructor(
        public nItemsSent: number
    ) {}

}

@Injectable({
    providedIn: 'root'
  })
export class LocationsService {

    constructor(private service: CRUDGenericService) { }

    get() {
        return new Observable<LocationDTO>(observer => {
            this.load(1, observer, true, new InternalState(0));
        });
    }

    load(page: number, observer: Subscriber<LocationDTO>, loadNexts: boolean, state: InternalState) {
        const nItemsPerPage = 500;
        this.service.getDataItem('routes/location?pageNumber=' + page + '&pageLenght=' + nItemsPerPage, true)
                .subscribe((data: PaginatedDTO<LocationDTO>) => {
                    const nPages = Math.ceil(data.total / nItemsPerPage);
                    if (nPages > 1 && loadNexts) {
                        for (let i = 1; i < nPages; i++) {
                            this.load(i + 1, observer, false, state);
                        }
                    }
                    for (const entry of data.contents ) {
                        state.nItemsSent++;
                        observer.next(entry);
                    }
                    if (state.nItemsSent >= data.total) {
                        console.log('All data was loaded: ' + state.nItemsSent + '/' + data.total);
                        observer.complete();
                    }
                });

    }
}
